import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const PharmacyList = ({ pharmacies }) => {
  return (
    <div className="pharmacyList">
     {pharmacies[0] ?pharmacies?.map((item, index) => (
        <div key={index} className="pharmacyGrid">
  
 <FontAwesomeIcon
      icon={faMapMarkerAlt}
      className="loc-marker"
      style={{ color: "red"}}
    />

          <div>
            <p className="pharmacyLabel">
               {item.name}</p>
            <p className="infoLine">Address: {item.address}</p>
            <p className="infoLine">
             City: {item.city} 
            </p>
             <p className="infoLine">State: {item.state}</p>
              <p className="infoLine">Zip: {item.zip}</p>
              <p className="infoLine">Contact Number: {item.contact}</p>
            {/* <p style={{ marginBottom: "3px" }}>Preferred Pharmacy : {item.pharmacyID}</p> */}
             {/* <p style={{ marginBottom: "3px" }}>Hours Of Operation (24 hour format):  */}
        <> Hours Of Operation (24-hour format):</>
            <div>
              {item.operationHoursDisplayList.map((hour, i) => (
                <p key={i} style={{ marginBottom: "2px", fontSize: "13px" }}>
                  {hour}
                </p>
              ))}
            </div>
            {/* </p> */}
              {/* <p style={{ marginBottom: "3px" }}>Coordinates: {item.latitude},{item.longitude}</p> */}
          </div>
        </div>
      )):<>
<FontAwesomeIcon
      icon={faExclamationCircle}
      className="ex-mark"
    />
No pharmacies available at location</>}
    </div>
  );
};

export default PharmacyList;